module.exports = __webpack_public_path__ + "static/media/invite-white.838be969.svg";